import { TransitionTypeFinder } from './TransitionTypeFinder';
import { TransitionType } from '../../utils/types';

export class CyclingTransitionTypeFinder implements TransitionTypeFinder {
    private readonly VIEWS_TO_CYCLE: Array<TransitionType> = [
        TransitionType.V3ToV4,
        TransitionType.None
    ];
    private currentViewIndex: number = 0;

    get(): TransitionType {
        const result = this.VIEWS_TO_CYCLE[this.currentViewIndex];
        return result;
    }

    update(): void {
        this.cycle();
    }

    private cycle() {
        this.currentViewIndex++;
        if (this.currentViewIndex === this.VIEWS_TO_CYCLE.length) {
            this.currentViewIndex = 0;
        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/services/transitionType/CyclingTransitionTypeFinder.ts